export const isDefaultCompanyBankAccountEnabledLocalStorageKey =
  "isDefaultCompanyBankAccountEnabled";
